import React from "react";
import { Card } from "primereact/card";
import MidiPlayer from "react-midi-player";
import { ExtendedSpecies } from "../types/species";
import { API_BASE_URL } from "../constants";

interface SpeciesDetailsProps {
  species: ExtendedSpecies;
}

export const SpeciesDetails = ({ species }: SpeciesDetailsProps) => {
  return (
    <div className="flex justify-content-center">
      <Card
        title={species.scientificName}
        className="w-full md:w-10 lg:w-8"
        header={
          <img
            src={species.wikipediaImage}
            alt={`${species.scientificName} species`}
            className="w-full"
          />
        }
      >
        {/* Taxonomy Section */}
        <div className="mb-5">
          <h2 className="section-title">Taxonomy</h2>
          <div className="flex flex-column">
            {[
              ["Kingdom", species.kingdom],
              ["Phylum", species.phylum],
              ["Class", species.class],
              ["Order", species.order],
              ["Family", species.family],
              ["Genus", species.genus],
              ["Species", species.scientificName],
            ].map(([label, value]) => (
              <div
                key={label}
                className="taxonomy-row flex justify-content-between align-items-center"
              >
                <span className="taxonomy-label">{label}</span>
                <span className="taxonomy-value">{value}</span>
              </div>
            ))}
          </div>
          
          <div className="barcode-section mt-4">
            <div className="flex justify-content-between align-items-center">
              <span className="font-bold">Barcode Index Number:</span>
              <a
                href={`http://v4.boldsystems.org/index.php/Public_BarcodeCluster?clusteruri=${species.clusteruri}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {species.clusteruri}
              </a>
            </div>
          </div>
        </div>

        {/* Listen Section */}
        <div className="mb-5">
          <h2 className="section-title">Listen to the SONIFIED SPECIES</h2>
          <div className="bg-white border-round p-3" style={{ border: '1px solid rgba(0,0,0,0.1)' }}>
            <MidiPlayer
              data={species.midiData}
              style={{ width: "100%", height: "200px" }}
            />
          </div>
          <div className="text-center mt-3">
            <a
              href={`http://v4.boldsystems.org/index.php/Public_RecordView?processid=${species.processid}`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-button-color"
              style={{ textTransform: 'uppercase', fontSize: '0.9rem' }}
            >
              MORE DETAILS
            </a>
          </div>
        </div>

        {/* Map Section */}
        <div className="mb-5">
          <h2 className="section-title">Molecular records of this species</h2>
          <div className="border-round overflow-hidden" style={{ border: '1px solid rgba(0,0,0,0.1)' }}>
            <img
              src={`${API_BASE_URL}/${species.map_link}`}
              title="Species Map"
              alt="Map showing known records of this species"
              style={{ width: "100%", height: "350px", objectFit: "cover", display: "block" }}
            />
          </div>
          <div className="text-center mt-3">
            <a
              href={`https://www.gbif.org/species/${species.usageKey}`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-button-color"
              style={{ textTransform: 'uppercase', fontSize: '0.9rem' }}
            >
              MORE DETAILS
            </a>
          </div>
        </div>

        {/* Description Section */}
        <div>
          <h2 className="section-title">Taxon Description</h2>
          <div className="line-height-3 text-justify" style={{ fontSize: '1rem', color: 'var(--text-primary)' }}>
            {species.wikipediaSummary}
          </div>
          <div className="text-center mt-4">
            <a
              href={species.wikipediaUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="link-button-color"
              style={{ textTransform: 'uppercase', fontSize: '0.9rem' }}
            >
              FULL ARTICLE ON WIKIPEDIA
            </a>
          </div>
        </div>
      </Card>
    </div>
  );
};
